import { CashRegisterState } from './state';

export const cashRegisterInitial: CashRegisterState = {
  cashRegisterList: undefined,
  preCashRegister: undefined,
};
